import styled from "styled-components";

export const WithdrawalContainer = styled.div`
  margin: 15px;
`;

export const WithdrawalTopCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block: 5px;
`;

export const WithdrawalTopCardButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  border-radius: 15px;
  width: calc(100% - 10px);
  height: 35px;
  font-weight: bold;
  margin-inline: 5px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const WithdrawalCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 15px;
  margin-block: 50px 10px;
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const WithdrawWrapper = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  height: 40px;
`;
export const WithdrawInput = styled.input`
  width: 100%;
  height: 40px;
  border: none;
  background-color: ${({ theme }) => theme.colors.primary};
  padding-inline: 10px;

  /* Chrome, Safari, Edge, Opera */
  &&::-webkit-outer-spin-button,
  &&::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &&[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }
`;

export const WithdrawalButton = styled.button`
  width: 30%;
  height: 40px;
`;
